export default __webpack_public_path__ + "static/media/Bg.e21961cb.png";